<template>
  <form
    class="business-registration__main-step"
    @submit.prevent="submitHandler"
  >
    <div class="business-registration__header">
      Выберите предоставляемые услуги
    </div>
    <div class="business-registration__step">Шаг регистрации 2 из 4</div>
    <small
      v-if="
        ($v.activeService.$dirty && !$v.activeService.required) ||
        ($v.activeService.$dirty && !$v.activeService.minLength)
      "
    >
      Выберите не менее 1 услуги, которая cможет охарактеризовать основную
      деятельность вашего салона
    </small>
    <small
      v-else-if="
        ($v.activeService.$dirty && !$v.activeService.required) ||
        ($v.activeService.$dirty && !$v.activeService.maxLength)
      "
    >
      Выберите не более 2 услуг, которые смогут охарактеризовать основную
      деятельность вашего салона
    </small>
    <div class="business-registration__services">
      <div
        class="business-registration__service"
        @click="checkService('Стрижка')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Стрижка') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="79"
            height="86"
            viewBox="0 0 79 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.8452 70.4321C22.7141 71.4365 27.9558 69.9299 30.5766 67.0423C30.5766 67.0423 56.4107 35.1533 56.4107 35.0277C57.0348 33.019 62.1517 6.27735 59.2812 5.77516C57.7836 5.52407 54.0395 12.1781 45.4281 35.6555C43.4313 39.4219 40.3112 44.3182 35.4439 49.3401C28.8294 56.1197 21.7156 60.5138 16.5987 63.1503C14.6019 66.5401 15.7251 69.5533 18.8452 70.4321Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.5877 78.3416C29.7911 78.3416 34.8199 73.2827 34.8199 67.0423C34.8199 60.8019 29.7911 55.743 23.5877 55.743C17.3843 55.743 12.3555 60.8019 12.3555 67.0423C12.3555 73.2827 17.3843 78.3416 23.5877 78.3416Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M23.5876 73.4453C27.1028 73.4453 29.9525 70.5786 29.9525 67.0423C29.9525 63.5061 27.1028 60.6394 23.5876 60.6394C20.0723 60.6394 17.2227 63.5061 17.2227 67.0423C17.2227 70.5786 20.0723 73.4453 23.5876 73.4453Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M3.74414 36.6599C3.86894 36.4088 6.24019 32.2657 10.9827 32.0146C14.3524 31.8891 17.4724 33.6467 19.2197 36.6599"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M19.2195 36.6599C19.3443 36.4088 21.7155 32.2657 26.458 32.0146C29.8277 31.8891 32.9478 33.6467 34.695 36.6599"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M34.5703 36.6599C34.6951 36.4088 37.0664 32.2657 41.8089 32.0146C45.1785 31.8891 48.2986 33.6467 50.0458 36.6599"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M19.2195 28.7504C19.3443 28.4993 21.7155 24.3562 26.458 24.1051C29.8277 23.9796 32.9478 25.7372 34.695 28.7504"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M34.5703 28.7504C34.6951 28.4993 37.0664 24.3562 41.8089 24.1051C45.1785 23.9796 48.2986 25.7372 50.0458 28.7504"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M50.0459 28.7504C50.1707 28.4993 52.542 24.3562 57.2844 24.1051C60.6541 23.9796 63.7742 25.7372 65.5214 28.7504"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M49.6714 21.3431C49.7962 21.092 52.1674 16.9489 56.9099 16.6978C60.2796 16.5723 63.3997 18.3299 65.1469 21.3431"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M34.1958 21.3431C34.3206 21.092 36.6919 16.9489 41.4343 16.6978C44.804 16.5723 47.9241 18.3299 49.6713 21.3431"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M62.4013 70.4321C58.5324 71.4365 53.2907 69.9299 50.6699 67.0423C50.6699 67.0423 24.8357 35.1533 24.8357 35.0277C24.2117 33.019 19.0948 6.27735 21.9653 5.77516C23.4629 5.52407 27.207 12.1781 35.8184 35.6555C37.8152 39.4219 40.9353 44.3182 45.8026 49.3401C52.4171 56.1197 59.5308 60.5138 64.6477 63.1503C66.6446 66.5401 65.5214 69.5533 62.4013 70.4321Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M57.1595 78.3416C63.3629 78.3416 68.3917 73.2827 68.3917 67.0423C68.3917 60.8019 63.3629 55.743 57.1595 55.743C50.9561 55.743 45.9272 60.8019 45.9272 67.0423C45.9272 73.2827 50.9561 78.3416 57.1595 78.3416Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M57.1596 73.4453C60.6749 73.4453 63.5245 70.5786 63.5245 67.0423C63.5245 63.5061 60.6749 60.6394 57.1596 60.6394C53.6444 60.6394 50.7947 63.5061 50.7947 67.0423C50.7947 70.5786 53.6444 73.4453 57.1596 73.4453Z"
              fill="white"
              :stroke="
                activeService.indexOf('Стрижка') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M66.7336 70.453L64.9863 73.4973L69.958 76.3849L71.7052 73.3406L66.7336 70.453Z"
              fill="white"
            />
            <path
              d="M16.8664 61.8904L15.1191 64.9347L20.0908 67.8223L21.838 64.778L16.8664 61.8904Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="business-registration__description">Стрижка</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Ногти')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Ногти') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="79"
            height="85"
            viewBox="0 0 79 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M69.1407 37.8467L25.4598 81.2774C22.9638 83.7591 19.0949 83.7591 16.5988 81.2774C14.1028 78.7956 14.1028 74.9489 16.5988 72.4671L60.2797 29.0365C62.7758 26.5547 66.6447 26.5547 69.1407 29.0365C71.512 31.3941 71.512 35.365 69.1407 37.8467Z"
              fill="white"
              :stroke="
                activeService.indexOf('Ногти') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M42.6825 45.292H40.3113V49.3869H42.6825V45.292Z"
              fill="white"
            />
            <path
              d="M24.8496 60.6943V63.052H28.9681V60.6943H24.8496Z"
              fill="white"
            />
            <path
              d="M30.8263 61.5474H21.3413C15.6004 61.5474 10.9827 56.8321 10.9827 51.2482V41.8175C10.9827 36.1095 15.7252 31.5182 21.3413 31.5182H30.8263C36.5672 31.5182 41.1849 36.2336 41.1849 41.8175V51.2482C41.3097 56.8321 36.5672 61.5474 30.8263 61.5474Z"
              fill="white"
              :stroke="
                activeService.indexOf('Ногти') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M31.7 28.5401V7.07296C31.7 3.97077 29.8279 1.36493 27.5815 1.36493H24.711C22.4646 1.36493 20.5925 3.97077 20.5925 7.07296V28.5401H31.7Z"
              :stroke="
                activeService.indexOf('Ногти') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M26.0837 28.1679V48.0219"
              :stroke="
                activeService.indexOf('Ногти') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M28.455 27.0511H26.7078V30.4015H28.455V27.0511Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="business-registration__description">Ногти</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Массаж')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Массаж') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="79"
            height="85"
            viewBox="0 0 79 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.0489 59.5621C49.7962 59.438 53.7898 59.0657 56.9099 55.9635C57.5339 55.4672 57.9083 54.8467 58.1579 54.4745L76.3791 35.365C77.6271 34 77.6271 31.8905 76.2543 30.5256C74.8815 29.2847 72.7598 29.2847 71.387 30.6497L61.278 41.1971C60.9036 41.3212 60.5292 41.3212 60.2796 41.073C60.03 40.8248 60.2796 40.0803 60.9036 39.584L74.6319 25.1898C75.8799 23.8248 75.8799 21.7154 74.5071 20.3504C73.1342 19.1095 71.0126 19.1095 69.6398 20.4745L57.6587 33.0073C57.1595 33.3796 56.6603 33.5037 56.4107 33.3796C56.1611 33.2555 56.2859 32.511 56.7851 32.0146L70.2638 17.8686C71.5118 16.5037 71.5118 14.3942 70.139 13.0292C68.7662 11.7883 66.6445 11.7883 65.2717 13.1533L51.6682 27.7956C51.2938 28.4161 50.545 28.5402 50.2954 28.4161C50.0458 28.292 50.0458 27.6716 50.4202 27.1752L63.8989 13.0292C65.1469 11.6643 65.1469 9.55477 63.774 8.18981C62.4012 6.94893 60.2796 6.94893 58.9068 8.3139C58.9068 8.3139 40.1864 28.5402 39.9368 28.4161C39.812 28.4161 39.6872 27.7956 39.812 25.438C39.6872 21.7154 39.5624 17.8686 39.5624 14.146C39.5624 12.2847 37.9399 10.7956 36.0679 10.7956H35.0695C33.1974 10.7956 31.6998 12.4088 31.6998 14.2701L32.0742 28.5402C31.3254 29.7811 30.327 31.7665 29.5782 34.2482C28.7045 37.3504 26.4581 44.6716 30.5766 51.2482C34.9447 58.073 42.932 59.9343 48.0489 59.5621Z"
              :stroke="
                activeService.indexOf('Массаж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M25.5846 14.2701C25.4598 16.6277 23.3381 19.4818 20.0933 19.4818C17.098 19.3577 14.8516 16.8759 14.8516 14.0219C14.8516 13.5256 14.9764 12.9051 15.7252 11.292C17.5972 7.19709 18.97 4.59125 20.4677 4.59125C21.9653 4.59125 22.9637 7.073 24.8358 11.5402C25.5846 13.1533 25.5846 13.6496 25.5846 14.2701Z"
              fill="white"
              :stroke="
                activeService.indexOf('Массаж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M31.6636 35.4499L28.7095 32.778L24.5105 37.3673L27.4646 40.0393L31.6636 35.4499Z"
              fill="white"
            />
            <path
              d="M34.8038 47.7684L30.4976 41.9833L25.6824 45.5267L29.9886 51.3117L34.8038 47.7684Z"
              fill="white"
            />
            <path
              d="M54.9548 61.8216L54.0698 55.3041L47.5148 56.1841L48.3998 62.7015L54.9548 61.8216Z"
              fill="white"
            />
            <path
              d="M33.447 78.4234C31.6998 78.2993 27.5813 78.0511 24.4612 75.1971C23.8372 74.7007 23.4628 74.2044 23.2132 73.8321L4.368 55.3431C2.99517 53.9781 2.99517 51.8686 4.368 50.5037C5.74083 49.1387 7.86247 49.1387 9.2353 50.5037L19.7187 60.6789C20.0931 60.8029 20.4675 60.8029 20.7171 60.5548C20.9667 60.3066 20.7171 59.5621 20.0931 59.1898L5.61603 45.292C4.2432 43.927 4.2432 41.8175 5.61603 40.4526C6.98885 39.0876 9.1105 39.0876 10.4833 40.4526L22.8388 52.4891C23.338 52.8613 23.8372 52.9854 24.0868 52.8613C24.3364 52.6132 24.2116 51.9927 23.5876 51.4964L9.60971 37.8467C8.23688 36.4818 8.23688 34.3723 9.60971 33.0073C10.9825 31.6424 13.1042 31.6424 14.477 33.0073L28.7045 46.9051C29.2037 47.5256 29.8277 47.6497 30.0773 47.4015C30.3269 47.2774 30.3269 46.657 29.9525 46.1606L15.9746 32.511C14.6018 31.146 14.6018 29.0365 15.9746 27.6715C17.3475 26.3066 19.4691 26.3066 20.8419 27.6715C20.8419 27.6715 40.1863 45.9124 40.3111 45.9124C40.8103 45.6642 40.3111 36.7299 40.3111 33.0073C40.3111 31.146 41.8088 29.5329 43.6808 29.5329H44.6792C46.5513 29.5329 48.1737 31.0219 48.1737 32.8832L48.2985 47.1533C49.0473 48.3942 50.1705 50.2555 50.9193 52.7372C51.9178 55.8394 54.4138 63.0365 50.4201 69.7372C46.5513 76.5621 38.5639 78.6716 33.447 78.4234Z"
              fill="white"
              :stroke="
                activeService.indexOf('Массаж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M15.0314 6.34897L13.2842 9.35785L18.2558 12.2119L20.003 9.20299L15.0314 6.34897Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="business-registration__description">Массаж</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Спа')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Спа') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="75"
            height="81"
            viewBox="0 0 75 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M53.91 12.6526C51.6588 9.69636 47.8673 7.92264 43.7204 8.63213C41.3507 9.10512 39.218 10.4059 37.6777 12.2978C37.5592 12.4161 37.4408 12.4161 37.3223 12.2978C35.782 10.4059 33.6493 8.98687 31.2796 8.63213C27.1327 7.92264 23.3412 9.69636 21.09 12.6526C20.9716 12.8891 9.71564 32.1635 1.54029 46.1168C1.4218 46.235 1.54029 46.3533 1.65877 46.4715L11.3744 52.0292C11.8483 52.2657 12.2038 52.5022 12.5592 52.857C12.6777 52.9752 12.9147 52.9752 12.9147 52.7387C15.9953 47.2993 19.1943 41.8599 22.2749 36.4204C22.3934 36.184 22.7488 36.3022 22.7488 36.5387C21.564 48.4818 20.2607 60.4248 19.0758 72.4861C19.0758 72.7226 19.0758 73.0774 19.0758 73.3139H35.1896H39.8104H55.9242C55.9242 73.0774 55.9242 72.7226 55.9242 72.4861C54.7393 60.5431 53.436 48.6 52.2512 36.5387C52.2512 36.3022 52.6066 36.184 52.7251 36.4204C55.8057 41.8599 59.0047 47.2993 62.0853 52.7387C62.2038 52.8569 62.3223 52.857 62.4408 52.857C62.7962 52.5022 63.1517 52.2657 63.6256 52.0292L73.3412 46.4715C73.4597 46.3533 73.4597 46.235 73.4597 46.1168C65.2844 32.1635 54.1469 12.8891 53.91 12.6526Z"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M22.5117 36.0657C27.488 36.0657 32.4643 36.0657 37.5591 36.0657C37.5591 48.4817 37.5591 60.8978 37.5591 73.4321"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M37.5593 36.184H45.4977"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M42.654 74.1416L38.1516 74.2598V69.1752H42.5355L42.654 74.1416Z"
              fill="white"
            />
            <path
              d="M26.5404 41.8599L20.9717 39.9679L22.8674 36.5387L26.6589 36.6569L26.5404 41.8599Z"
              fill="white"
            />
            <path
              d="M24.052 39.8496H21.3269V43.5153H24.052V39.8496Z"
              fill="white"
            />
            <path
              d="M42.2986 42.0963C42.4171 42.0963 48.4597 31.8088 48.4597 31.8088C48.1043 30.508 46.9194 29.6803 45.6161 29.6803C44.3128 29.6803 43.0095 30.508 42.654 31.8088"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M48.4597 31.8088C48.1042 30.508 46.9194 29.6803 45.7345 29.6803C44.4312 29.6803 43.1279 30.508 42.7725 31.8088C44.7867 35.238 46.9194 38.6672 48.9336 42.0963"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M47.0378 37.7212L44.7866 34.0555L46.2084 33.346L48.2226 36.8935L47.0378 37.7212Z"
              fill="white"
            />
            <path
              d="M47.6302 6.26715H27.488V13.2438H47.6302V6.26715Z"
              fill="white"
            />
            <path
              d="M37.7964 36.184V22.2307L44.5499 7.21315L44.6684 6.8584C43.1281 5.91242 40.7584 4.96643 37.7964 4.96643C34.8343 4.96643 32.4646 6.03066 30.9243 6.97665C32.5831 10.6423 34.2419 14.308 35.9006 17.8555"
              :stroke="
                activeService.indexOf('Спа') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="business-registration__description">Спа</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Барбер')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Барбер') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="80"
            height="87"
            viewBox="0 0 80 87"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M56.6192 24.7665C54.3443 22.9883 51.4375 22.2263 48.5307 22.6073C47.7724 22.7343 47.7724 23.7504 48.5307 23.8774C49.5418 24.1314 50.5528 24.5124 51.5639 25.2745C52.0694 25.6555 55.4817 28.1956 55.1026 32.2599C55.1026 32.3869 54.7234 36.1971 51.4375 37.9752C49.1626 39.2453 46.5086 38.8643 44.7392 37.9752C42.338 36.7051 42.5907 34.927 39.9367 33.784C39.3048 33.53 37.4091 32.7679 35.2606 33.2759C34.6286 33.4029 33.9967 33.784 33.4912 34.038C33.2384 34.165 32.9857 34.165 32.7329 34.038C32.2274 33.657 31.5955 33.4029 30.9636 33.2759C28.8151 32.7679 26.9193 33.4029 26.2874 33.784C23.6334 34.927 23.8861 36.8321 21.4849 37.9752C19.7155 38.8643 17.0615 39.2453 14.7866 37.9752C11.5007 36.1971 11.1215 32.3869 11.1215 32.2599C10.7424 28.1956 14.1547 25.6555 14.6602 25.2745C15.6713 24.5124 16.6824 24.1314 17.6934 23.8774C18.4517 23.7504 18.4517 22.6073 17.6934 22.6073C14.7866 22.3533 11.8798 22.9883 9.60495 24.7665C5.05518 28.3227 5.30795 34.038 5.30795 35.054C5.56071 41.6584 10.7424 45.5956 11.8798 46.4847C17.3143 50.6759 26.2874 52.327 31.7219 47.8818C32.2274 47.5008 32.6065 46.9927 33.1121 46.4847C33.6176 46.9927 33.9967 47.5008 34.5023 47.8818C39.9367 52.327 48.9098 50.6759 54.3443 46.4847C55.6081 45.5956 60.6634 41.6584 60.9162 35.054C60.9162 34.038 61.1689 28.1956 56.6192 24.7665Z"
              :stroke="
                activeService.indexOf('Барбер') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M47.6613 35.4552L43.4509 37.1881L46.1333 43.7699L50.3436 42.037L47.6613 35.4552Z"
              fill="white"
            />
            <path
              d="M35.8766 29.1085L31.6663 30.8414L34.3486 37.4233L38.5589 35.6904L35.8766 29.1085Z"
              fill="white"
            />
            <path
              d="M42.317 44.6301L38.1067 46.363L40.789 52.9449L44.9994 51.212L42.317 44.6301Z"
              fill="white"
            />
            <path
              d="M52.0561 45.2473L47.8457 46.9802L50.528 53.5621L54.7384 51.8292L52.0561 45.2473Z"
              fill="white"
            />
            <path
              d="M70.7742 5.08028C67.8674 4.31823 64.8342 5.96933 64.0759 8.8905L55.2292 41.2774C55.1028 42.2934 55.2292 43.8175 55.7347 45.4686C56.3666 47.5007 57.6304 48.8978 58.7679 49.9138L55.2292 62.7416C48.91 45.4686 42.5909 28.3226 36.3982 11.4306C35.5135 8.8905 32.4803 6.98539 29.4472 6.98539C26.5404 6.98539 25.1502 9.39852 26.2876 12.0657C34.8816 32.1328 43.3492 51.819 51.8168 71.3781C51.9432 71.6321 51.9432 71.7591 52.0696 72.0131C51.1849 74.0452 51.1849 75.8233 51.1849 76.4584C51.1849 76.9664 51.3113 78.2365 51.6905 79.6336C52.0696 80.9036 52.4488 81.7927 53.0807 82.0467C53.5862 82.1737 54.3445 81.9197 54.7236 81.4117C55.1028 80.7766 54.4709 80.1416 54.0917 78.2365C53.839 76.9664 53.5862 76.0774 54.0917 75.1883C54.2181 74.9343 54.3445 74.8073 54.5973 74.5533C54.5973 74.5533 54.5973 74.5533 54.7236 74.5533C56.1138 74.9343 57.504 74.1722 57.8832 72.7752L65.8453 43.9445L69.0048 32.2598L74.3129 12.7007L74.5657 11.8117C75.324 8.8905 73.5546 5.84232 70.7742 5.08028ZM54.9764 71.2511C53.9653 71.2511 53.207 70.489 53.3334 69.473C53.3334 68.4569 54.0917 67.6949 55.1028 67.8219C56.1138 67.8219 56.8721 68.5839 56.7458 69.6C56.7458 70.489 55.9875 71.2511 54.9764 71.2511Z"
              fill="white"
              :stroke="
                activeService.indexOf('Барбер') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
          </svg>
        </div>
        <div class="business-registration__description">Барбер</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Макияж')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Макияж') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="85"
            height="93"
            viewBox="0 0 85 93"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43.2385 69.9197V80.1022"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M27.9304 80.1022H56.9352"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M43.2385 73.0423C62.575 73.0423 78.1517 57.1576 78.1517 37.743H8.32544C8.32544 57.1576 24.0363 73.0423 43.2385 73.0423Z"
              fill="white"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M43.2386 66.6614C59.1092 66.6614 71.9748 53.6535 71.9748 37.6074C71.9748 21.5613 59.1092 8.55334 43.2386 8.55334C27.3681 8.55334 14.5024 21.5613 14.5024 37.6074C14.5024 53.6535 27.3681 66.6614 43.2386 66.6614Z"
              fill="white"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M43.2384 59.7373C55.3267 59.7373 65.1263 49.8294 65.1263 37.6073C65.1263 25.3853 55.3267 15.4774 43.2384 15.4774C31.1501 15.4774 21.3506 25.3853 21.3506 37.6073C21.3506 49.8294 31.1501 59.7373 43.2384 59.7373Z"
              fill="white"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M27.7719 17.9464L24.0688 21.6904L59.3903 57.4026L63.0934 53.6586L27.7719 17.9464Z"
              fill="white"
            />
            <path
              d="M34.3759 22.5372L29.4075 28.2394"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M38.8072 22.5372C38.6729 22.4015 29.4075 33.6701 29.4075 33.6701"
              :stroke="
                activeService.indexOf('Макияж') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="business-registration__description">Макияж</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Брови')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Брови') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="88"
            height="95"
            viewBox="0 0 88 95"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M63.8105 35.781C58.5277 32.7299 54.4961 32.0364 53.1059 31.7591C50.0475 31.343 47.5451 31.4817 46.2939 31.6204C46.2939 31.6204 45.7378 31.7591 45.5988 31.7591L10.4266 42.2992C7.78523 43.1313 5.97796 46.5985 6.67306 50.0656C7.64621 54.0875 11.1217 56.7226 14.1802 55.7518L49.4914 45.0729C51.9938 44.2408 55.7473 43.1313 60.613 43.4087C62.9764 43.5474 67.9811 43.6861 73.681 46.7372C80.91 50.6204 84.6636 56.4452 84.8026 56.3065C85.2197 55.8904 75.6273 42.4379 63.8105 35.781Z"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M24.7291 33.2425L15.1531 36.1503L17.2177 42.917L26.7938 40.0093L24.7291 33.2425Z"
              fill="white"
            />
            <path
              d="M34.0861 49.9344L24.458 47.2043L22.1015 55.4753L31.7296 58.2053L34.0861 49.9344Z"
              fill="white"
            />
            <path
              d="M50.8384 35.0386L43.052 28.7648L37.6365 35.4536L45.4229 41.7274L50.8384 35.0386Z"
              fill="white"
            />
            <path
              d="M59.5444 29.6256L51.7581 23.3518L46.3426 30.0406L54.1289 36.3144L59.5444 29.6256Z"
              fill="white"
            />
            <path
              d="M49.5625 42.8939L41.7761 36.6201L36.3606 43.3089L44.147 49.5827L49.5625 42.8939Z"
              fill="white"
            />
            <path
              d="M20.4361 65.5985C19.88 68.0949 18.3508 69.7591 16.8215 70.4525L20.4361 65.5985Z"
              fill="white"
            />
            <path
              d="M20.4361 65.5985C19.88 68.0949 18.3508 69.7591 16.8215 70.4525"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.0774 67.9562C22.5213 70.5912 20.9921 72.5328 19.4629 73.3649L23.0774 67.9562Z"
              fill="white"
            />
            <path
              d="M23.0774 67.9562C22.5213 70.5912 20.9921 72.5328 19.4629 73.3649"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.5797 69.7592C25.1626 72.5329 23.7724 74.4745 22.2432 75.4453L25.5797 69.7592Z"
              fill="white"
            />
            <path
              d="M25.5797 69.7592C25.1626 72.5329 23.7724 74.4745 22.2432 75.4453"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28.4993 71.9781C28.2213 74.3358 27.1091 76 25.8579 77.1095L28.4993 71.9781Z"
              fill="white"
            />
            <path
              d="M28.4993 71.9781C28.2213 74.3358 27.1091 76 25.8579 77.1095"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M30.8625 73.6423C30.7235 75.8613 29.8894 77.6642 28.6382 78.7737L30.8625 73.6423Z"
              fill="white"
            />
            <path
              d="M30.8625 73.6423C30.7235 75.8613 29.8894 77.6642 28.6382 78.7737"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M33.7821 74.8905C33.9211 76.9708 33.365 78.7737 32.3918 80.1606L33.7821 74.8905Z"
              fill="white"
            />
            <path
              d="M33.7821 74.8905C33.9211 76.9708 33.365 78.7737 32.3918 80.1606"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M36.5625 75.8613C36.8405 77.8029 36.5625 79.6058 35.5894 80.9927L36.5625 75.8613Z"
              fill="white"
            />
            <path
              d="M36.5625 75.8613C36.8405 77.8029 36.5625 79.6058 35.5894 80.9927"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M39.4817 76.5547C40.0378 78.0802 40.1768 79.8832 39.4817 81.5474V76.5547Z"
              fill="white"
            />
            <path
              d="M39.4817 76.5547C40.0378 78.0802 40.1768 79.8832 39.4817 81.5474"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M42.9573 76.8322C43.7914 78.3577 44.0694 80.1606 43.6524 81.9635L42.9573 76.8322Z"
              fill="white"
            />
            <path
              d="M42.9573 76.8322C43.7914 78.3577 44.0694 80.1606 43.6524 81.9635"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M46.0159 76.2773C46.989 77.6642 47.5451 79.4671 47.128 81.4087L46.0159 76.2773Z"
              fill="white"
            />
            <path
              d="M46.0159 76.2773C46.989 77.6642 47.5451 79.4671 47.128 81.4087"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M49.4915 75.8613C50.6036 77.1095 51.1597 79.0511 50.8817 80.9927L49.4915 75.8613Z"
              fill="white"
            />
            <path
              d="M49.4915 75.8613C50.6036 77.1095 51.1597 79.0511 50.8817 80.9927"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M52.5498 74.6132C53.662 75.8613 54.3571 77.6643 54.218 79.7445L52.5498 74.6132Z"
              fill="white"
            />
            <path
              d="M52.5498 74.6132C53.662 75.8613 54.3571 77.6643 54.218 79.7445"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M55.8862 73.6423C57.1374 74.7518 58.1106 76.5547 57.9715 78.7737L55.8862 73.6423Z"
              fill="white"
            />
            <path
              d="M55.8862 73.6423C57.1374 74.7518 58.1106 76.5547 57.9715 78.7737"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M58.9446 72.1168C60.3348 73.0876 61.3079 75.0292 61.3079 77.1095L58.9446 72.1168Z"
              fill="white"
            />
            <path
              d="M58.9446 72.1168C60.3348 73.0876 61.3079 75.0292 61.3079 77.1095"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M61.7251 70.1752C63.2543 70.8686 64.6445 72.6715 64.7835 74.8905L61.7251 70.1752Z"
              fill="white"
            />
            <path
              d="M61.7251 70.1752C63.2543 70.8686 64.6445 72.6715 64.7835 74.8905"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M64.3665 67.9562C65.8957 68.6496 67.2859 70.4525 67.4249 72.6715L64.3665 67.9562Z"
              fill="white"
            />
            <path
              d="M64.3665 67.9562C65.8957 68.6496 67.2859 70.4525 67.4249 72.6715"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M66.3127 65.1825C67.981 65.7372 69.5102 67.4015 69.7883 69.6205L66.3127 65.1825Z"
              fill="white"
            />
            <path
              d="M66.3127 65.1825C67.981 65.7372 69.5102 67.4015 69.7883 69.6205"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M67.7029 62.5475C69.5101 62.8249 71.1784 64.3504 71.5955 66.5694L67.7029 62.5475Z"
              fill="white"
            />
            <path
              d="M67.7029 62.5475C69.5101 62.8249 71.1784 64.3504 71.5955 66.5694"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.1848 63.2409C19.7409 63.9343 28.7772 77.2482 44.4866 76.5548C55.6082 76.1387 65.4787 68.7883 69.7883 58.1095"
              fill="white"
            />
            <path
              d="M19.1848 63.2409C19.7409 63.9343 28.7772 77.2482 44.4866 76.5548C55.6082 76.1387 65.4787 68.7883 69.7883 58.1095"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M66.7299 9.4306C68.8152 11.0948 69.3713 14.0072 67.8421 15.8102L37.9526 54.0875C36.4234 56.0291 33.504 56.1678 31.4187 54.5036C29.3334 52.8394 28.7773 49.927 30.3065 48.124L60.1959 9.84666C61.5861 7.90506 64.6446 7.76637 66.7299 9.4306Z"
              fill="white"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M37.5355 54.5037C33.3649 57.1387 29.1943 59.9124 25.0237 62.5475C26.6919 57.8321 28.2212 53.2555 29.8894 48.5402C30.7235 48.5402 32.6698 48.8175 34.6161 50.3431C36.5624 52.0073 37.2575 53.8102 37.5355 54.5037Z"
              fill="white"
              :stroke="
                activeService.indexOf('Брови') === -1 ? '#1E3958' : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="business-registration__description">Брови</div>
      </div>
      <div
        class="business-registration__service"
        @click="checkService('Депиляция')"
        :class="{
          'business-registration__service_active':
            activeService.indexOf('Депиляция') !== -1,
        }"
      >
        <div class="business-registration__img">
          <svg
            width="97"
            height="104"
            viewBox="0 0 97 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.1944 51.7723C27.1233 51.7723 41.8342 63.7665 44.286 79.4044H52.7141C55.166 63.9183 69.8769 51.7723 87.8058 51.7723C90.1043 51.7723 94.5483 42.0555 94.5483 36.8935C83.5151 40.0818 67.425 43.5738 47.8105 43.4219C28.8089 43.2701 13.1786 39.7781 2.4519 36.438C2.4519 41.7519 6.89582 51.7723 9.1944 51.7723Z"
              :stroke="
                activeService.indexOf('Депиляция') === -1
                  ? '#1E3958'
                  : '#bd3c2b'
              "
              stroke-miterlimit="10"
            />
            <path
              d="M43.6731 51.9242C43.8263 51.9242 52.8674 40.2336 52.8674 40.2336C52.2545 38.7154 50.5688 37.8044 48.73 37.8044C46.7379 37.8044 44.899 38.8672 44.286 40.2336"
              :stroke="
                activeService.indexOf('Депиляция') === -1
                  ? '#1E3958'
                  : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M52.7142 40.2336C52.1012 38.8672 50.4156 37.8044 48.5767 37.8044C46.5846 37.8044 44.7458 38.7154 44.1328 40.2336C47.1976 44.1811 50.2624 48.1285 53.3271 51.9242"
              :stroke="
                activeService.indexOf('Депиляция') === -1
                  ? '#1E3958'
                  : '#bd3c2b'
              "
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M50.5687 47.0656L47.0442 42.6627L49.496 42.0554L52.5608 46.0029L50.5687 47.0656Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="business-registration__description">Депиляция</div>
      </div>
    </div>
    <button type="submit" class="business-registration__button">
      Продолжить регистрацию
    </button>
  </form>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: "BaseRegistrationForBusinessUserStepTwo",
  data() {
    return {
      activeService: [],
    };
  },
  validations: {
    activeService: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(2),
    },
  },
  methods: {
    submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      const FormData = {
        activeService: this.activeService,
      };
      this.$emit("change-slide", 3, FormData);
    },
    checkService(name) {
      if (this.activeService.indexOf(name) === -1) {
        this.activeService.push(name);
      } else {
        this.activeService = this.activeService.filter((item) => item !== name);
      }
    },
  },
};
</script>
<style lang="sass">
small
  font-size: 90% !important
  color: $palette-red
  text-align: center
.path
  stroke: red
.business-registration
  &__services
    max-width: 744px
    margin: 0 auto
    display: flex
    flex-wrap: wrap
    justify-content: space-between
  &__img
    display: block
    pointer-events: none
    user-select: none
    margin-bottom: 20px
  &__description
    position: absolute
    bottom: 14px
    left: 50%
    transform: translateX(-50%)
    font-size: 18px
    line-height: 16px
    text-align: center
    color: #000145
  &__service
    position: relative
    cursor: pointer
    width: 153px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    height: 153px
    background: #FFFFFF
    border: 1px solid #000145
    box-sizing: border-box
    margin: 16.5px
    transition: 0.2s ease-in-out
    &_active
      border: 1px solid $palette-red
      .business-registration__description
        color: rgba(189,60,43, .9)
</style>
